<template>
    <el-tag style="height: auto" :type="getTagType"
      >{{ $t('common_words.code') }}: {{ article.code }} <br />
      {{ $t('common_words.name') }}: {{ article.name }}
      <br />
      {{ $t('inventory.toxicity_classification') }}: {{ article.toxicity_classification_name }}
      <br />
      {{ $t('common_words.symbol') }}: {{ article.supplying_unit_name }} <br />
    </el-tag>
  </template>
  <script>
  export default {
    name: 'articles-tag',
    props: {
      article: {
        type: Object,
        required: true,
      },
    },
    computed: {
      getTagType() {
        return this.article.deleted_at ? `danger` : `info`;
      },
    },
  };
  </script>
  